import React from "react";
import { useTranslation } from "react-i18next";

export const InviteLinkSuccess: React.FC = () => {
  const { t } = useTranslation("CommandHub");

  return <span>{t("command.generateInviteLink.success.message")}</span>;
};

export const renderInviteLinkSuccess = () => <InviteLinkSuccess />;
